module.exports = __webpack_public_path__ + "static/media/raze.9e84fb06.png";